export enum SectionChapterEnum {
	Link,
	List,
}
